import { render } from "./OverlayDemo.vue?vue&type=template&id=c2cf4548&scoped=true"
import script from "./OverlayDemo.vue?vue&type=script&lang=js"
export * from "./OverlayDemo.vue?vue&type=script&lang=js"

import "./OverlayDemo.vue?vue&type=style&index=0&id=c2cf4548&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2cf4548"]])

export default __exports__